import type { FaireProductEntity } from "../../entity_types/product";

export const p_4e7u473ct9: FaireProductEntity = {
  token: "p_4e7u473ct9",
  type: "product",
  name: "Coco Vanilla Shampoo Bars x 2 | Organic, Eco-friendly, Plastic-free",
  brandToken: "b_v44qpcjjza",
  brandName: "Lyness",
  imageUrl:
    "https://cdn.faire.com/fastly/012d3788df30deb321f81d58e8058ec7c9d7e1e75c929515cad5d9be2348af53.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7771e4ed1fd6bc5ddb10750c63a52df38fe0d8f7218c3c13cf2ac052860fe546.jpeg",
    "https://cdn.faire.com/fastly/9ae939146f5c4128e275f04c073dc89f9d2a16a84f49ffd1228f158b65fd1c63.jpeg",
    "https://cdn.faire.com/fastly/46c6e050e6005bd26dd317a9f1e0bc76ed4149c5db7f800d02378b7aae6e6f71.jpeg",
    "https://cdn.faire.com/fastly/e1d678e13d169ada85c91d341929d6e12c8b7bbaf22cf727ac69932df79444fc.jpeg",
    "https://cdn.faire.com/fastly/e422d29437503e7951a1b8c7978e9ea38ab5737fd5483f5628da5970eefdff78.jpeg",
    "https://cdn.faire.com/fastly/cf7a9bc1166369ecb907dc0a23aa5bc06f4f9271383126457c318814365c9def.jpeg",
    "https://cdn.faire.com/fastly/b3ebdb2d0a1e7eb64ec4f16f6f1805494797e372bb706280be5c5dcfc5e51cde.jpeg",
    "https://cdn.faire.com/fastly/d6a42f8329297aaae45dd75ab899b33feecc00db91b76be446fed6b6185952a8.jpeg",
  ],
  priceDollars: 20.99,
  description:
    "A creamy blend of coconut and vanilla that deeply moisturizes, tames frizz, and helps strengthen brittle hair.\n\n * Gentle & Nourishing Cleanse: Sodium Coco Sulfate, derived from coconuts, creates a rich lather that cleans without harsh SLS. \n * Coconut & Vanilla Nourishment: Coconut oil helps prevent dryness, dandruff, split ends, and breakage while sealing in moisture for smooth, frizz-free strands. Vanilla essential oil adds a soothing touch, supports scalp comfort, and smooths the cuticle for silky, healthy-looking hair. \n * Cocoa, Shea & Olive Oils: Cocoa butter, shea butter, and olive oil nourish, soften, and restore hair, helping improve manageability and resilience. \n * Eco-Friendly & Travel-Ready: Each bar lasts as long as three bottles of liquid shampoo and comes in a reusable aluminium tin. ",
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:08.307Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
